/**
 * Application roles enum
 * These match the role values in the JWT token
 */
export enum UserRole {
  FLEET_MANAGER = 'fleet_manager',
  SITE_MANAGER = 'site_manager',
  USER = 'user',
  OFFLINE_ACCESS = 'offline_access',
  UMA_AUTHORIZATION = 'uma_authorization',
}
